import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { SiteConfigProvider } from "@/hooks/useSiteConfig";
import Home from "@/pages/Home";
import WhitepaperPage from "@/pages/WhitepaperPage";

const SmoothScroll = ({ children }) => {
  const lenisRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!reduced) {
      const lenis = new Lenis({ lerp: 0.1 });
      lenisRef.current = lenis;
      let raf;
      const loop = (t) => {
        lenis.raf(t);
        raf = requestAnimationFrame(loop);
      };
      raf = requestAnimationFrame(loop);
      return () => {
        cancelAnimationFrame(raf);
        lenis.destroy();
      };
    }
  }, []);

  useEffect(() => {
    const handler = (e) => {
      const target = document.querySelector(e.detail);
      if (!target) return;
      if (lenisRef.current) {
        lenisRef.current.scrollTo(target, { offset: -72, duration: 1.4 });
      } else {
        target.scrollIntoView();
      }
    };
    window.addEventListener("jcv:scroll", handler);
    return () => window.removeEventListener("jcv:scroll", handler);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    lenisRef.current?.scrollTo(0, { immediate: true });
  }, [location.pathname]);

  return children;
};

function App() {
  return (
    <SiteConfigProvider>
      <BrowserRouter>
        <SmoothScroll>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/whitepaper" element={<WhitepaperPage />} />
          </Routes>
        </SmoothScroll>
      </BrowserRouter>
    </SiteConfigProvider>
  );
}

export default App;
